import { createFileRoute } from "@tanstack/react-router";
import { optionalLiteralParam, parseableSearchSchema } from "@crm/effect/schema/search";
import { Schema } from "effect";

const feedbacksSearchSchema = parseableSearchSchema(
  Schema.Struct({
    day: optionalLiteralParam("all", "0", "1", "2", "3"),
  }),
);

export const Route = createFileRoute("/_protected/dashboard/metrics/_details/feedbacks/")({
  validateSearch: feedbacksSearchSchema
});
